<i
    class="{{ selector }} {{ appendClass }}"
    [class.fa-spin]="animated"
    [class.fa-border]="bordered"
    [style.color]="color | safe: 'style'"
></i>
